import Signing from './Signing';

const Practice = () => {
  return <Signing isPractice={true} />;
};

export default Practice;
